module.exports = __webpack_public_path__ + "img/tag.1a432497.png";